/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * SettingsLabels Styled
 *
 * @author Aleksandr Perkhunov
 * @version 1.3.0
 * @since 1.3.0
 */

import styled from 'styled-components';

import { colors } from '../../../../../../theme';

export const SettingsLabelsContentStyled = styled.div`
    width: 600px;
`;

export const SettingsLabelsListStyled = styled.div`
    border-top: 1px solid ${colors.borderColorSeparate};
    line-height: 20px;
`;

export const SettingsLabelsItemStyled = styled.div`
    border-bottom: 1px solid ${colors.borderColorSeparate};
    display: flex;
    padding: 12px;
`;

export const SettingsLabelsItemTextStyled = styled.div`
    flex-basis: 100%;
    display: flex;
`;

export const SettingsLabelsItemRemoveStyled = styled.div`
    cursor: pointer;
    position: relative;

    > div {
        position: absolute;
        top: -6px;
        right: -6px;
    }
`;
